import React, {useEffect, useState} from 'react';
import moment from 'moment';
import {useParams} from "react-router-dom";
import {observer} from "mobx-react";
import {assessmentApi} from "../api/assessmentApi";
import {usersStore} from "../store/usersStore";
import {Menu} from "../menu/menu";
import {Spinner} from "../controls/spinner";
import homeStyle from '../main/home.scss';
import style from './meetingTranscript.scss';

export const MeetingTranscript = observer(function MeetingTranscript() {
  const {meetingId, userId} = useParams();
  const [assessment, setAssessment] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      setAssessment(await assessmentApi.getAssessmentForMeetingAndUser(meetingId, userId));
      setLoaded(true);
    })();
  }, [meetingId, userId]);

  const turns = [...(assessment?.conversationTurns || [])].sort((a, b) => a.startEpochSec - b.startEpochSec);

  return (
    <div className={homeStyle.home}>
      <Menu/>
      <div className={homeStyle.list}>
        <div className={style.header}>Transcript for {getUserName(userId)}</div>
        {!loaded && <Spinner/>}
        {loaded && !assessment && <div className={style.empty}>No transcript found for this user in this meeting</div>}
        {loaded && assessment && assessment.status !== 'completed' &&
          <div className={style.empty}>Transcript status: {assessment.status}</div>
        }
        {loaded && assessment && turns.length === 0 && assessment.status === 'completed' &&
          <div className={style.empty}>No conversation turns recorded</div>
        }
        {loaded && assessment && turns.length > 0 &&
          <div className={style.conversation}>
            {turns.map((turn, i) => (
              <Turn key={i} turn={turn}/>
            ))}
          </div>
        }
      </div>
    </div>
  );
});

function Turn({turn}) {
  return (
    <div className={`${style.turn} ${turn.isHost ? style.host : style.guest}`}>
      <div className={style.turnMeta}>
        <span className={style.speaker}>{turn.isHost ? "Teacher" : getUserName(turn.userId)}</span>
        <span className={style.turnTime}>{formatRange(turn.startEpochSec, turn.endEpochSec)}</span>
      </div>
      <div className={style.text}>{turn.text}</div>
      {turn.assessment?.hasGrammaticalError &&
        <div className={style.assessment}>&#9888; {turn.assessment.analysis}</div>
      }
    </div>
  );
}

function formatRange(startEpochSec, endEpochSec) {
  return `${moment.unix(startEpochSec).format("mm:ss")} - ${moment.unix(endEpochSec).format("mm:ss")}`;
}

function getUserName(userId) {
  if (userId === 'allusers') return "All users";
  return usersStore.getUserById(userId)?.name || userId;
}